export const defaultEventProfileWidgets = [
	{
		index: 0,
		enabled: true,
		id: "activities"
	},
	{
		index: 1,
		enabled: true,
		id: "map"
	},
	{
		index: 2,
		enabled: true,
		id: "notes"
	},
	{
		index: 3,
		enabled: true,
		id: "event_lists"
	},
	{
		index: 4,
		enabled: true,
		id: "pinned_items"
	},
	{
		index: 5,
		enabled: true,
		id: "files"
	},
	{
		index: 6,
		enabled: true,
		id: "cad_details"
	},
	{
		index: 7,
		enabled: true,
		id: "responding_units"
	},
	{
		index: 8,
		enabled: true,
		id: "cameras"
	},
	{
		index: 9,
		enabled: true,
		id: "proximity"
	},
	{
		index: 10,
		enabled: true,
		id: "resources"
	},
	{
		index: 11,
		enabled: true,
		id: "equipments"
	},
	{
		index: 12,
		enabled: true,
		id: "gate_runner_response"
	},
	{
		index: 13,
		enabled: true,
		id: "patrols"
	}
];
